IntlMessageFormat.__addLocaleData({"locale":"ss","pluralRuleFunction":function (n,ord){if(ord)return"other";return n==1?"one":"other"}});
IntlMessageFormat.__addLocaleData({"locale":"ss-SZ","parentLocale":"ss"});
IntlMessageFormat.__addLocaleData({"locale":"ss-ZA","parentLocale":"ss"});
